var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalletFill = function SvgWalletFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F80",
    d: "m18.491 5.67-3.352 2.519-3.964 2.973v3.269l8.242-6.19.002-.035q0-1.543-.928-2.537"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.382 12.309a4 4 0 0 0-.426-.199L15.41 14.01q.409.405.41 1.085c0 .53-.182.955-.548 1.228q-.548.41-1.64.41H8.97V7.16h4.407q.867 0 1.357.42.287.248.404.608l3.353-2.52a4 4 0 0 0-.702-.589Q16.16 4 13.036 4H5.08v15.913h7.887q3.466 0 5.29-1.16 1.823-1.158 1.823-3.364 0-1.067-.422-1.841-.422-.773-1.277-1.239"
  })));
};
export default SvgWalletFill;